export default __webpack_public_path__ + "static/media/fag.5207e82e.jpg";